// ResetHeadingStyle.js
'use strict';
import { css } from 'styled-components';

export const ResetHeadingStyle = css`
  margin: 0;
`;

export default ResetHeadingStyle;
